import React from "react";
const More = () => {
  return(
    <h1>More Screen</h1>
  );
};
export default More;